module.exports = __webpack_public_path__ + "srh-3a949992dd8b68ef9056.png";